"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFiles = exports.File = exports.decodeFile = void 0;

var http_1 = require("./http/http");

var files_1 = __importStar(require("./http/files"));

function decodeFile(f) {
  return new File(f.name, f.path, f.createdBy, new Date(f.created));
}

exports.decodeFile = decodeFile;

var File =
/** @class */
function () {
  function File(name, path, createdBy, created, content) {
    if (createdBy === void 0) {
      createdBy = "";
    }

    if (created === void 0) {
      created = new Date();
    }

    if (content === void 0) {
      content = "";
    }

    this.name = name;
    this.path = path;
    this.createdBy = createdBy;
    this.created = created;
    this.content = content;
  } /// Returns a url string to use in e.g. <img src={f.link(cred)} />


  File.prototype.link = function (uuid, credentials) {
    // example https://api.comsel.net/v5/files/cd7d92c1-aebf-4a90-b1c9-e54f0dcc015c/install/instsallpic0.jpg?token=fca87b2bd250cd40691025121841a6669a27bcba0d2ba991153fc31f
    return http_1.apiRoot + "/v5/files/" + uuid.string() + "/" + this.path + "/" + this.name + "?token=" + credentials.token();
  };

  File.prototype.create = function (uuid, credentials) {
    return files_1.createFile(this.name, this.path, this.content, uuid, credentials);
  };

  return File;
}();

exports.File = File;

function getFiles(uuid, credentials) {
  return files_1.default(uuid, credentials).then(function (ret) {
    var e_1, _a;

    var files = [];

    try {
      for (var ret_1 = __values(ret), ret_1_1 = ret_1.next(); !ret_1_1.done; ret_1_1 = ret_1.next()) {
        var r = ret_1_1.value;
        files.push(decodeFile(r));
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (ret_1_1 && !ret_1_1.done && (_a = ret_1.return)) _a.call(ret_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    return files;
  });
}

exports.getFiles = getFiles;